<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
    import {fade} from 'svelte/transition';
    
    import axios from "axios";

    let menuRef = [];
	let isLoaded;

    class PageInfo {
        constructor({page=1, perPageNum=20, totalCount=100}) {
            this.totalCount = totalCount;
            this.setPage(page, perPageNum); 
        }

        setPage(page=1, perPageNum=20) {
            this.page = page;
            this.perPageNum = perPageNum;
            this.showPage = 10;
            this.pageStartNum = (page - 1) * perPageNum;
            this.endPage = Math.ceil(page / this.showPage) * this.showPage;
            this.startPage = this.endPage - this.showPage + 1;
            let tempEndPage = Math.ceil(this.totalCount / perPageNum);
            if ( this.endPage > tempEndPage) {
                this.endPage = tempEndPage;
            }
            this.prev = this.startPage != 1;
            this.next = this.endPage * perPageNum < this.totalCount; 
            this.pageList=[]; 
            for (let i = this.startPage; i <= this.endPage; i++) { 
                this.pageList.push(i);
            }
        }

        getListNumber(index) {
            return (this.page - 1) * this.perPageNum + index;
        }
        clickPrev() {
            this.setPage(this.page - 1);
            getUserList();
        }
        clickNext() {
            this.setPage(this.page + 1);
            getUserList();
        }
        clickPage(page) {
            this.setPage(page);
            getUserList();
        }
        clickSearch() {
            this.setPage();
            getUserList();
        }
        enter(e) {
            if (e.key === "Enter") {
                this.clickSearch();
            }
        }
    }

    let eventList = [];

    onMount(() => {
        getEventPreList();
    });

	const getEventPreList = () => {
		PRConnect.send("/api/Event/getEventPreList", {}, data => {
            if( data.header.status === "success") {
                eventList = data.result;
				isLoaded = true;
            }
        });
	}

    const clickMenu = (idx) => {
		menuRef = [];
        menuRef[idx] = !menuRef[idx];
    }

    const clickEventCreate = () => {
        PRConnect.send("/api/Event/createEvent", {}, data => {
            if( data.header.status === "success") {
                navigateTo(`/event-builder/${data.result.id}`);
            }
        });
    }

	const clickEventDelete = (eventId) => {
		PRConnect.send("/api/Event/deleteEvent", {id: eventId}, data => {
            if( data.header.status === "success") {
				menuRef = [];
                getEventPreList();
            }
        });
	}

</script>
<div class="container home" style="">
    <div class="title-wrapper">
        <div class="title-inner">
            <div class="title1">Home</div>
            <div class="title-main">이벤트목록</div>
            <div class="title-sub">내가 관리하고 있는 이벤트 목록입니다.</div>
        </div>
    </div>
	{#if isLoaded}
       <div class="ava-event" on:click={()=>menuRef = []}>
            <div class="event-con-wrap">
                <div class="avatalk-card new cursor" on:click|stopPropagation={clickEventCreate}>
                    <div class="text-block-5">새로운 이벤트 만들기</div>
                    <img src="/static/images/new-ava-icon.svg" loading="lazy">
                </div>
                {#each eventList as event, idx}
                <div class="event-con pointer" on:click={()=>navigateTo(`/event-builder/${event.id}`)}>
                    <img src="{event.thumbnailContent}" loading="lazy" alt="" class="image-142">
                    <div class="event-box">
                        <div class="event-box-con">
						{#if event.proccessType == "PUBLISH" && new Date(event.endDate).getTime() > new Date().getTime() && new Date(event.startDate).getTime() < new Date().getTime()}
                        <div class="open-noti">오픈</div>
							{#if event.eventType === "RECOMMEND"}
							<div class="participate">{event.cnt}명 참여</div>
							{/if}
						{:else if event.proccessType == "PUBLISH" && new Date(event.endDate).getTime() > new Date().getTime()}
						<div class="open-noti">오픈 예정</div>
						{:else if event.proccessType == "PUBLISH"}
						<div class="open-noti none">마감</div>
						{:else}
						<div class="open-noti unpublish">게시전</div>
						{/if}
                        </div>
                        <div class="admin-hambuger-menu" on:click|stopPropagation>
                            <div class="menu-button" on:click={()=>clickMenu(idx)}></div>
                            <div class="hambuger-popup" class:block={menuRef[idx]}>
                                <div class="frofile-correct">
									<a href="#" class="link" on:click={()=> navigateTo(`/event-builder/${event.id}`)}>이벤트 수정</a>
                                </div>
								{#if event.proccessType == "PUBLISH"}
								<div class="copy">
									<a href="#" class="link green" on:click={()=> navigateTo(`/event/${event.id}`)}>게시글 보기</a>
                                </div>
								{/if}
                                <div class="delete" on:click={()=> clickEventDelete(event.id)}>
	                                <a href="#" class="link red">삭제</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="event-title1">{event.thumbnailTitle}</div>
                    <div class="event-sub1">{event.thumbnailSubTitle}</div>
                </div>
                {/each}
            </div>
        </div>
	{/if}
</div>
<style>
    .avatalk-card {
        height: auto;
    }
    .event-con {
        padding: 25px;
        border: 1px solid lightgrey;
        border-radius: 10px;
    }

    .event-box {
        position: initial;
    }
    .image-142 {
        padding: 6px;
        border-radius: 10px;
        border: none;
    }
    .menu-button {
        background-position: -16px 4px;
        height: 30px;
    }
    .block {
        display: block;
    }
	.unpublish {
		background-color: #36C3FF;
	}
	.ava-event {
		margin-top: 40px;
	}
</style>